var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("event-card", {
    staticClass: "my-3",
    attrs: {
      title: _vm.entry.payload_type_description,
      icon: _vm.getEventIcon(_vm.entry.origin_id),
      color: _vm.getEventColor(_vm.entry.origin_id),
      date: _vm.entry.entry_datetime,
      children: _vm.entry.entries,
      "icon-tooltip": _vm.entry.origin_description,
      resume: _vm.entry.resume,
      subtitle:
        _vm.entry.origin_id === _vm.COM_P1_ORIGIN_ID
          ? _vm.entry.payload.ptm_typ
          : null,
      subsubtitle:
        _vm.entry.origin_id === _vm.COM_P1_ORIGIN_ID
          ? _vm.entry.payload.ptm_lib
          : null,
      author: `${_vm.entry.author_name} (${_vm.entry.author_type})`
    },
    scopedSlots: _vm._u(
      [
        {
          key: "actions",
          fn: function() {
            return [
              _vm._t("default"),
              _vm._v(" "),
              _c("documents-menu", {
                attrs: {
                  propertyId: _vm.entry.property_id,
                  actionId: Number(_vm.entry.external_id),
                  "document-exists": _vm.entry.document_exists
                }
              }),
              _vm._v(" "),
              _c(
                _vm.btn,
                _vm._b({ tag: "component" }, "component", _vm.btnProps, false)
              )
            ]
          },
          proxy: true
        }
      ],
      null,
      true
    )
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }